import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
  Button,
  Modal
} from 'react-bootstrap';

// Locale
import messages from '../../../../locale/jsonMessages';

// Redux Action
import { importiCal } from '../../../../actions/Listing/ImportCalendar';
import CommonFormComponent from '../../../CommonField/CommonFormComponent';
import validate from './validate';

import cs from '../../../commonStyle.css';
import s from './ImportCalendar.css';
class ImportCalendar extends React.Component {
  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    close: PropTypes.any.isRequired,
    reset: PropTypes.any.isRequired,
    importiCal: PropTypes.any.isRequired,
    listId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      url: '',
      name: ''
    }
    this.submitForm = this.submitForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { showModal, dispatch, reset } = this.props;
    if (prevProps.showModal !== showModal) {
      dispatch(reset('ImportCalendar'));
    }
  }

  handleClose = () => {
    const { dispatch, reset, close } = this.props;
    close();
    dispatch(reset('ImportCalendar'));
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  async submitForm() {
    const { reset, close, importiCal, listId, dispatch } = this.props;
    const { url, name } = this.state;
    close();
    importiCal(listId, name, url)
    dispatch(reset('ImportCalendar'));
  }

  render() {
    const { showModal, close, error, handleSubmit, submitting } = this.props;
    const { url, name } = this.state;
    const { formatMessage } = this.props.intl;
    return (
      <Modal show={showModal} onHide={close} animation={false} dialogClassName='commonModalContainer globalModalContainer'>
        <Modal.Header className='commonModalHeader' closeButton>
          <Modal.Title className='commonModalTitle'><FormattedMessage {...messages.importCalendarLabel} /></Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass='commonModalBody'>
          <p className={cx(s.introText, cs.commonMediumText, cs.spaceBottom3)}><FormattedMessage {...messages.importCalendarDesc1} /></p>
          <div className='oneColumnGrid'>
            <Field
              name="url"
              type="text"
              component={CommonFormComponent}
              placeholder={formatMessage(messages.icalPlaceHolderTextOne)}
              labelText={formatMessage(messages.importCalendarDesc2)}
              inputClass='commonInputField'
              onChange={this.handleChange}
            />

            <Field
              name="name"
              type="text"
              component={CommonFormComponent}
              placeholder={formatMessage(messages.icalPlaceHolderTextTwo)}
              inputClass='commonInputField'
              onChange={this.handleChange}
              labelText={formatMessage(messages.importCalendarDesc3)}
            />
          </div>

          <div className={cx(cs.spaceTop4, 'doubleBtnFlexEnd')}>
            <Button
              className={cs.btnPrimaryBorder}
              type="button"
              disabled={submitting}
              onClick={this.handleClose}
            >
              <FormattedMessage {...messages.cancel} />
            </Button>
            <Button
              className={cs.btnPrimary}
              type="button"
              disabled={submitting}
              onClick={handleSubmit(this.submitForm)}
            >
              <FormattedMessage {...messages.importCalendarDesc4} />
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

ImportCalendar = reduxForm({
  form: 'ImportCalendar', // a unique name for this form
  validate,
  shouldValidate: () => true
})(ImportCalendar);

const mapState = (state) => ({
});

const mapDispatch = {
  importiCal
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(ImportCalendar)));
